"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCard = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Card_1 = __importDefault(require("@opsbase/web-layout/Card"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = color => {
    return {
        root: {
            maxWidth: 260,
            minWidth: 260,
            minHeight: 260,
            maxHeight: 260,
            position: 'relative',
            margin: '0 0 16px 16px',
            background: color.background,
            transition: 'background 0.33s',
            '&:hover': {
                background: color.main,
            },
            '& .MuiTypography-root': {
                color: color.dark,
                transition: 'color 0.33s',
            },
            '&:hover .MuiTypography-root': {
                color: lib_palette_1.default.White.main,
            },
            '& .MuiSvgIcon-root': {
                fill: color.dark,
            },
            '&:hover .MuiSvgIcon-root': {
                fill: lib_palette_1.default.White.main,
            },
        },
        inner: {
            position: 'relative',
            zIndex: 10,
        },
    };
};
function ButtonCard(props) {
    const { onClick, icon, color = lib_palette_1.default.positive, label, subLabel } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [color]);
    return (react_1.default.createElement(Card_1.default, { classes: { root: myCss.root }, padding: true, onClick: onClick, center: true },
        react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true, shrink: true, style: { minWidth: 220 } },
            icon,
            react_1.default.createElement(Text_1.default, { centered: true, variant: "h0" }, label),
            !!subLabel && (react_1.default.createElement(Text_1.default, { centered: true, variant: "body" }, subLabel)))));
}
exports.ButtonCard = ButtonCard;
exports.default = ButtonCard;
